import { createFileRoute } from '@tanstack/react-router'
import { SchoolSettingsClient } from '../components/SchoolSettingsClient'

export const Route = createFileRoute('/school/$schoolId/settings')({
  head: () => ({
    meta: [{ title: 'School Settings | Unbreakable' }],
  }),
  component: SchoolSettingsPage,
})

function SchoolSettingsPage() {
  return <SchoolSettingsClient />
}
